import { generateId } from "@app/utils/generateId";
import { Pill, PillsInput } from "@mantine/core";
import { forwardRef, useEffect, useState } from "react";

interface IMulti {
  onChange: (data: string[]) => void;
  value: string[];
  label: string;
  placeholder: string;
  className?: string;
  required?: boolean;
}

export const MultiInput = forwardRef<HTMLInputElement, IMulti>(function TextField(
  { onChange, label, placeholder, required, className, value, ...rest },
  ref
) {
  const [pills, setPills] = useState<{ data: string; id: string }[]>([]);

  const [data, setData] = useState("");

  const addPill = () => {
    setPills((state) => [...state, { data, id: generateId() }]);
    onChange([...pills, { data, id: generateId() }].map((x) => x.data));
    setData("");
  };

  const deletePill = (id: string) => {
    const filter = pills.filter((x) => x.id !== id);
    setPills(filter);
    onChange(filter.map((x) => x.data));
  };

  useEffect(() => {
    if (value && value.length > 0) {
      setPills(value.map((row) => ({ data: row, id: generateId() })));
    }
  }, [value]);

  return (
    <PillsInput
      required={required}
      label={label}
      ref={ref}
      size="xs"
      className={`${className} secondary-color`}
      data-testid="multiinput-container"
    >
      <Pill.Group data-testid="multiinput-pills-group">
        {pills.map((p, idx) => {
          return (
            <Pill key={p.id} data-testid={`multiinput-pill-${idx}`}>
              {p.data}
              <span
                className="pointer "
                data-testid={`multiinput-pill-delete-${idx}`}
                onClick={() => {
                  deletePill(p.id);
                }}
              >
                &nbsp; x
              </span>
            </Pill>
          );
        })}
        <PillsInput.Field
          placeholder={placeholder}
          data-testid="multiinput-field"
          onChange={(e) => {
            setData(e.target.value);
          }}
          className={`${className} secondary-color`}
          value={data}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              addPill();
            }
          }}
          {...rest}
        />
      </Pill.Group>
    </PillsInput>
  );
});
